export default __webpack_public_path__ + "static/amador-loureiro-BVyNlchWqzs-unsplash-408482389859e06e4f31f5e6afb8ed1b.jpg";